import {z} from 'zod';

/**
 * Schema for multipart file upload to storage service
 */
export const storageUploadFileRequestSchema = z.object({
  file: z.any(),
  namespace: z.string(),
  filename: z.string().optional(),
  webhookUrls: z.string().optional(),
  deleteAt: z.string().optional(),
});

export type StorageUploadFileRequest = z.infer<typeof storageUploadFileRequestSchema>;
